var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlob3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "214px",
    height: "181px",
    viewBox: "0 0 214 181",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1.44424438%",
    y1: "0%",
    x2: "100%",
    y2: "100%",
    id: "linearGradient-blob-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17EAD9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6078EA",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "paid-courses",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.201674107
  }, /*#__PURE__*/React.createElement("g", {
    id: "payment-final-stage,-input-details",
    transform: "translate(-982.000000, -292.000000)",
    fill: "url(#linearGradient-blob-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval-+-Path-6-+-Path-8-Mask",
    transform: "translate(261.000000, 164.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M733.272064,175.003844 C716.879155,187.841296 713.426432,221.888379 744.863845,246.728637 C776.301258,271.568895 827.984048,247.403721 851.624472,295.16706 C875.264896,342.930398 986.515146,252.285541 906.434252,185.088599 C871.398674,155.689781 890.728782,152.798906 864.314263,133.964635 C833.980499,112.335836 817.920844,156.023646 784.944533,162.166392 C750.427856,168.596074 749.664974,162.166392 733.272064,175.003844 Z",
    id: "Path-8",
    transform: "translate(828.000000, 218.259933) rotate(180.000000) translate(-828.000000, -218.259933) "
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlob3);
export default __webpack_public_path__ + "static/media/blob_3.eb8960c0.svg";
export { ForwardRef as ReactComponent };